import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import * as ActionsLogin from '../../redux/modules/login';
import Auth from '../../services/auth';

const FORM_NAME = 'PartnerForm';

class Login extends PureComponent {

  login = (values) => {
    const { login, history } = this.props;
    login(values).then((reponse) => {
      const AuthServices = Auth;
      AuthServices.setUserInfo(reponse.data);
      history.push('/');
    })
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <div className="contacts-container container">
        <div className="row">
          <div className="col-sm-6 col-sm-offset-3 form-box">
            <div className="form-top">
              <div className="form-top-left">
                <h3>Login to Backoffice</h3>
                <p>Enter your email and password to log on:</p>
              </div>
            </div>
            <div className="form-bottom">
              <form className="login-form" onSubmit={handleSubmit(this.login.bind(this))}>
                <div className="form-group">
                  <label className="sr-only">Username</label>
                  <Field
                    className="form-password form-control"
                    name="email"
                    component="input"
                    type="text"
                    placeholder="Email"/>
                </div>
                <div className="form-group">
                  <label className="sr-only">Password</label>
                  <Field
                    className="form-password form-control"
                    name="password"
                    component="input"
                    type="password"
                    placeholder="Password"/>
                </div>
                <button type="submit" className="btn">Sign in!</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const LoginForm = reduxForm({
  form: FORM_NAME
})(Login);

export default connect(
  (state) => {
    return {
      login: state.login,
      enableReinitialize: true,
      initialValues: { email: 'admin@planetmedicalsolutions.com', password: 'admin' }
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        login: ActionsLogin.post
      }, dispatch);
  }
)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/login/Login.js